import Login from "../auth/Login";
import Dashboard from "../pages/Dashboard";
import { UserManagement } from "../pages/UserManagement";
import TrackingManagement from "../pages/TrackingManagement";
import Community from "../pages/Community";
import Revenue from "../pages/Revenue";
import Analysis from "../pages/Analysis";
import Week from "../pages/Week";
import Profile from "../pages/Profile";
import MyRegimen from "../pages/MyRegimen";
import ShowGraph from "../pages/ShowGraph";
import { SubscriptionManagement } from "../pages/SubscriptionManagement";
import { QuoteManagement } from "../pages/QuoteManagement";
import Verification from "../auth/Verification";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoute from "./ProtectedRoute";
import { Navigate } from "react-router-dom";
import ProtectLoginRoute from "./ProtectLoginRoute";
import { VideoLink } from "../pages/VideoLink";
import ChangePassword from "../auth/ChangePassword";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/ResetPassword";
import LandingManagement from "../pages/LandingManagement";
import { CourseManagement } from "../pages/CourseManagement";
import UIPagesManagement from "../pages/UIPagesManagement";
import Settings from "../pages/Settings";
import Testimonial from "../pages/Testimonial";

const routes =
  [
    {
      path: "/login",
      element: (
        <ProtectLoginRoute>
          <Login />
        </ProtectLoginRoute>
      ),
    },
    {
      path: "/change-password",
      element: (
        <PrivateRoute>
          <ChangePassword />
        </PrivateRoute>
      ),
    },
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: "/user-management",
      element: (
        <PrivateRoute>
          <UserManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/course-management",
      element: (
        <PrivateRoute>
          <CourseManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/week-management",
      element: (
        <PrivateRoute>
          <Week />
        </PrivateRoute>
      ),
    },
    {
      path: "/tracking-management",
      element: (
        <PrivateRoute>
          <TrackingManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/myregimen",
      element: (
        <PrivateRoute>
          <MyRegimen />
        </PrivateRoute>
      ),
    },
    {
      path: "/community",
      element: (
        <PrivateRoute>
          <Community />
        </PrivateRoute>
      ),
    },
    {
      path: "/revenue",
      element: (
        <PrivateRoute>
          <Revenue />
        </PrivateRoute>
      ),
    },
    {
      path: "/analysis",
      element: (
        <PrivateRoute>
          <Analysis />
        </PrivateRoute>
      ),
    },
    {
      path: "/quote-management",
      element: (
        <PrivateRoute>
          <QuoteManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/subscription-management",
      element: (
        <PrivateRoute>
          <SubscriptionManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/forgot-password",
      element: (
        <ProtectLoginRoute>
          <ForgotPassword />
        </ProtectLoginRoute>
      ),
    },
    {
      path: "/verification",
      element: (
        <ProtectedRoute data={"resetpass"}>
          <Verification />
        </ProtectedRoute>
      ),
    },
    {
      path: "/reset-password",
      element: (
        <ProtectedRoute data="verify">
          <ResetPassword />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile",
      element: (
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      ),
    },
    {
      path: "/showgraph",
      element: (
        <PrivateRoute>
          <ShowGraph />
        </PrivateRoute>
      ),
    },
    {
      path: "/video-management",
      element: (
        <PrivateRoute>
          <VideoLink />
        </PrivateRoute>
      ),
    },
    // {
    //   path: "/home-management",
    //   element: (
    //     <PrivateRoute>
    //       <HomeManagement />
    //     </PrivateRoute>
    //   ),
    // },
    {
      path: "/ui-management",
      element: (
        <PrivateRoute>
          <UIPagesManagement />
        </PrivateRoute>
      ),
    },
    {
      path: "/landing-management",
      element: (
        <PrivateRoute>
          <LandingManagement />
        </PrivateRoute>
      ),
    }, {
      path: "/testimonial",
      element: (
        <PrivateRoute>
          <Testimonial />
        </PrivateRoute>
      ),
    },
    {
      path: "/Settings",
      element: (
        <PrivateRoute>
          <Settings />
        </PrivateRoute>
      ),
    },
    {
      path: "*",
      element: <Navigate to="/" />,
    },
  ];
export default routes;
